import { Box, CircularProgress, makeStyles } from "@material-ui/core";
import { dashboardAssets } from "../../assets/exports";
import { appConstants } from "../../utils";
import { WithdrawInfoType } from "./type";

const WithdrawInfo = ({ rewards, loading }: WithdrawInfoType) => {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <div className={classes.imgContainer}>
        <img src={dashboardAssets.DafiRewards} className={classes.img} />
        <small>You will get up to</small>
        <Box
          minHeight={50}
          display="flex"
          justifyContent="center"
          alignItems="center"
        >
          {loading ? (
            <CircularProgress className={classes.rewardLoaderColor} />
          ) : (
            <div
              className={[classes.dafiAmount, classes.rewardColor].join(" ")}
            >
              {Number(rewards)
                ? Number(rewards * appConstants.AMOUNT_FEE_RATIO)?.toFixed(4)
                : 0}
            </div>
          )}
        </Box>
        <span className={classes.text}>{appConstants.APP_TOKEN_NAME}</span>
      </div>
    </div>
  );
};

export default WithdrawInfo;

const useStyles = makeStyles((theme) => ({
  container: { width: "100%" },
  dafiAmount: {
    fontSize: "28px",
    fontWeight: 700,
    margin: "5px 0px",
  },
  rewardLoaderColor: {
    color: "rgba(135, 151, 255, 1)",
  },

  rewardColor: {
    background: theme.palette.textGradient2,
    "-webkit-background-clip": "text",
    "-webkit-text-fill-color": "transparent",
  },
  img: { marginBottom: "20px", height: 80 },
  imgContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    background: "rgba(15, 8, 36, 0.55)",
    border: "1px solid rgba(230, 231, 233, 0.1)",
    boxShadow:
      " inset 0px 23.0177px 33.051px -33px rgba(255, 255, 255, 0.5), inset 0px -48.3961px 40.1333px -37.7725px rgba(255, 255, 255, 0.12), inset 0px 57.8392px 59.0196px -28.3294px rgba(255, 255, 255, 0.09), inset 0px 2.36078px 10.6235px rgba(8, 5, 18, 0.2), inset 0px 0.590196px 23.6078px rgba(8, 5, 18, 0.2)",
    backdropFilter: "blur(25px)",
    paddingTop: "25px",
    paddingBottom: "30px",
    marginBottom: "20px",
    borderRadius: "25px",
    color: "white",
    "@media(max-width:550px)": {
      paddingTop: "16px",
      paddingBottom: "16px",
    },
  },

  text: {
    fontSize: "20px",
  },
}));
